import type SystemNotificationRequestModel from 'ab-requestModels/systemNotification.requestModel';

import * as TimeUtils from '@acceligentllc/shared/utils/time';
import * as TimeOptionUtils from '@acceligentllc/shared/utils/timeOption';

import type { SystemNotificationType } from '@acceligentllc/shared/enums/systemNotificationType';
import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';
import type { TimeOptionValues } from '@acceligentllc/shared/enums/timeOption';

class SystemNotificationFM {
	id: number;
	type: SystemNotificationType;
	content: string;
	startsAt: Date;
	startsAtDate?: string; // only on unparsed version
	startsAtTime?: TimeOptionValues; // only on unparsed version
	endsAt: Date;
	endsAtDate?: string; // only on unparsed version
	endsAtTime?: TimeOptionValues; // only on unparsed version

	static fromFMtoRM(unparsedForm: SystemNotificationFM): SystemNotificationRequestModel {
		if (!unparsedForm.startsAtDate || !unparsedForm.startsAtTime || !unparsedForm.endsAtDate || !unparsedForm.endsAtTime) {
			throw new Error('Times and dates not provided');
		}

		const startsAtTime = TimeOptionUtils.toNumber(unparsedForm.startsAtTime);
		const endsAtTime = TimeOptionUtils.toNumber(unparsedForm.endsAtTime);
		if (!startsAtTime || !endsAtTime) {
			throw new Error('Times in incorrect format');
		}

		const type = unparsedForm.type;
		const content = unparsedForm.content;

		const startsAtMoment = TimeUtils.parseMoment(unparsedForm.startsAtDate, TimeFormat.DATE_ONLY);
		const endsAtMoment = TimeUtils.parseMoment(unparsedForm.endsAtDate, TimeFormat.DATE_ONLY);
		if (!startsAtMoment || !endsAtMoment) {
			throw new Error('Times in incorrect format');
		}

		const startsAt = startsAtMoment.add(startsAtTime, 'minutes').toDate();
		const endsAt = endsAtMoment.add(endsAtTime, 'minutes').toDate();

		return {
			id: unparsedForm.id,
			type,
			content,
			startsAt,
			endsAt,
		};
	}
}

export default SystemNotificationFM;
